import type { MachineSelectOption } from '@/components/machines/MachineSelect';
import { machineOptionLabel } from '@/lib/machineLabel';

function optionalString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function venueNameFromRow(row: Record<string, unknown>): string | null {
  const venue = row.venue;
  if (venue && typeof venue === 'object') {
    return optionalString((venue as Record<string, unknown>).name);
  }
  return optionalString(row.venueName);
}

export function toMachineSelectOption(raw: unknown): MachineSelectOption | null {
  if (!raw || typeof raw !== 'object') return null;

  const row = raw as Record<string, unknown>;
  const machine =
    row.machine && typeof row.machine === 'object'
      ? (row.machine as Record<string, unknown>)
      : row;

  if (typeof machine.id !== 'string') return null;

  const name = optionalString(machine.name);
  const serialNumber = optionalString(machine.serialNumber);
  const venueName = venueNameFromRow(machine);

  const option: MachineSelectOption = {
    id: machine.id,
    name: name ?? '',
    serialNumber,
    venueName,
  };

  return option;
}

export function parseMachineSelectOptions(data: unknown): MachineSelectOption[] {
  const rows = Array.isArray(data)
    ? data
    : data &&
        typeof data === 'object' &&
        'items' in data &&
        Array.isArray((data as { items: unknown }).items)
      ? (data as { items: unknown[] }).items
      : [];

  return rows
    .map((row) => toMachineSelectOption(row))
    .filter((row): row is MachineSelectOption => row !== null)
    .sort((a, b) =>
      machineOptionLabel(a).localeCompare(machineOptionLabel(b), undefined, {
        sensitivity: 'base',
      })
    );
}
